import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useHttpHook from "../../Hooks/HttpHook";
import { logout } from "../../ReduxSlice/Auth/authSlice";
import { guardLogin } from "../../ReduxSlice/Auth/guardSlice";
import { GuardLoginApi } from "../../utils/ApiConstant";
import { GuardLanguage } from "../../utils/Languages";
import MainComponentWrapper from "../Common/MainComponentWrapper";
import Input from "../UiElement/FormElement/Input";
import { showErrorToast } from "../../utils/notify";

const GuardLogin = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.guard);
  const [loading, sendRequest, error] = useHttpHook();

  // Match event SSO: if already authenticated, skip the login screen.
  useEffect(() => {
    if (token) {
      navigate("/guard/attendees", { replace: true });
    }
  }, [token, navigate]);

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
      }
    }
  }, [error]);

  const onSubmit = async (data) => {
    try {
      const res = await sendRequest(
        GuardLoginApi,
        {
          method: "POST",
          data,
        },
        false
      );
      if (res.status === 1) {
        // Guard and user sessions conflict — clear user so guard APIs keep working
        dispatch(logout());
        localStorage.removeItem("userData");
        dispatch(guardLogin(res.data));
        localStorage.setItem("guardData", JSON.stringify(res.data));
        navigate(`/guard/attendees`);
      }
    } catch (submitError) {
      console.log({ error: submitError });
    }
  };

  return (
    <MainComponentWrapper errorInfo={error} Loading={loading}>
      <div className="event-guard-login">
        <div className="event-guard-login-card">
          <p className="event-guard-login-subtitle">
            Sign in with your guard credentials to manage event check-ins and
            attendee access.
          </p>
          <form
            className="event-guard-login-form"
            id="guard-login"
            onSubmit={handleSubmit(onSubmit)}
          >
            <Input
              ValidationArr={[{ Type: "required" }]}
              CustomFormGroupCls="event-guard-login-field"
              InputClassName="event-guard-login-input"
              element="email"
              Id="guard-login-email"
              FieldName="email"
              Register={register}
              Errors={errors}
              placeholder={GuardLanguage.Login.form.email.placeHolder}
              Label={GuardLanguage.Login.form.email.label}
            />
            <Input
              ValidationArr={[{ Type: "required" }]}
              CustomFormGroupCls="event-guard-login-field"
              InputClassName="event-guard-login-input"
              element="password"
              Id="guard-login-password"
              FieldName="password"
              Register={register}
              Errors={errors}
              placeholder={GuardLanguage.Login.form.password.placeHolder}
              Label={GuardLanguage.Login.form.password.label}
            />
            <button
              type="submit"
              className="event-guard-login-btn"
              disabled={loading}
            >
              {GuardLanguage.Login.submitText}
            </button>
          </form>
        </div>
      </div>
    </MainComponentWrapper>
  );
};

export default GuardLogin;
